import React from "react";
import PdfPage from "../components/PdfPage";

const SecpInvestorGuide = () => {
  return (
    <main className="main-container">
      <PdfPage
        h2={"Secp Investor Guide"}
        img={"/img/secp-logo.jpg"}
        pdf1={"/img/Investor Guide SECP ENGLISH.pdf"}
        pdf1Text={"Download  In English"}
        pdf2={"/img/Investor-Guide-SECP-URDU-1.pdf"}
        pdf2Text={"Download In Urdu"}
      />
    </main>
  );
};

export default SecpInvestorGuide;
